import { Metamodel } from 'app/model/base/model';
import { compressionCodecType } from 'shell-models-lib';
import { CompressionReadSettings } from './compression-read-settings';
import { IModel, IAttribute } from 'app/model/base/annotation';


@Metamodel.model({
    name: 'TarGZipReadSettings',
    display: [],
    tags: { compressionType: compressionCodecType.TarGZip }
})

export class TarGZipCompressionReadSettings extends CompressionReadSettings {
    public static readonly MODEL: IModel;
    public static readonly PRESERVE_COMPRESSIONFILE_NAME_AS_FOLDER: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'PRESERVE_COMPRESSIONFILE_NAME_AS_FOLDER',
        display: stringResources.ModelName_PreserveCompressionFileNameAsFolder
    })
    public preserveCompressionFileNameAsFolder: boolean;
}
